export default __webpack_public_path__ + "static/media/Countdown-from-5-sec-v3-trans.86158576.gif";